/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Escape text before interpolating into HTML markup (ag-grid innerHTML, template strings).
 *
 * **Canonical helper — do not duplicate.** Import this from components and utils that build
 * HTML strings; see `esci-tools/CLAUDE.md` and `.cursor/rules/angular-typescript-standards.mdc`.
 *
 * @example
 * import {escapeHtml} from '../../utils/html.util';
 * return `<span>${escapeHtml(displayValue)}</span>`;
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
